import React from 'react';
interface SkeletonLoaderProps {
  type: 'community' | 'event' | 'job' | 'movie' | 'article';
  count?: number;
  grid?: boolean;
  className?: string;
}
const SkeletonLoader: React.FC<SkeletonLoaderProps> = ({
  type,
  count = 1,
  grid = false,
  className = ''
}) => {
  const renderSkeleton = () => {
    switch (type) {
      case 'community':
        return <CommunityCardSkeleton data-id="element-435" />;
      case 'event':
        return <EventCardSkeleton data-id="element-436" />;
      case 'job':
        return <JobCardSkeleton data-id="element-437" />;
      case 'movie':
        return <MovieCardSkeleton data-id="element-438" />;
      case 'article':
        return <ArticleCardSkeleton data-id="element-439" />;
      default:
        return <div className="h-24 bg-gray-200 rounded-lg animate-pulse" data-id="element-440"></div>;
    }
  };
  const items = Array.from({
    length: count
  }, (_, index) => <div key={index} className={className} data-id="element-441">
        {renderSkeleton()}
      </div>);
  if (grid) {
    return <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-442">{items}</div>;
  }
  return <>{items}</>;
};
const CommunityCardSkeleton = () => {
  return <div className="border border-gray-300 rounded-lg p-4 relative animate-pulse" data-id="element-443">
      <div className="flex justify-between items-start" data-id="element-444">
        <div className="w-12 h-12 bg-gray-300 rounded-full" data-id="element-445"></div>
        <div className="flex space-x-2" data-id="element-446">
          <div className="w-6 h-6 bg-gray-300 rounded-full" data-id="element-447"></div>
          <div className="w-20 h-6 bg-gray-300 rounded-full" data-id="element-448"></div>
        </div>
      </div>
      <div className="mt-2" data-id="element-449">
        <div className="h-6 bg-gray-300 rounded w-3/4" data-id="element-450"></div>
      </div>
      <div className="mt-2" data-id="element-451">
        <div className="h-4 bg-gray-300 rounded w-full" data-id="element-452"></div>
        <div className="h-4 bg-gray-300 rounded w-5/6 mt-1" data-id="element-453"></div>
      </div>
      <div className="mt-2" data-id="element-454">
        <div className="h-4 bg-gray-300 rounded w-1/3" data-id="element-455"></div>
      </div>
      <div className="mt-1" data-id="element-456">
        <div className="h-4 bg-gray-300 rounded w-1/2" data-id="element-457"></div>
      </div>
      <div className="mt-3 flex justify-end" data-id="element-458">
        <div className="h-4 bg-gray-300 rounded w-1/4" data-id="element-459"></div>
      </div>
    </div>;
};
const EventCardSkeleton = () => {
  return <div className="border border-gray-300 rounded-lg p-4 animate-pulse" data-id="element-460">
      <div className="h-6 bg-gray-300 rounded w-3/4 mb-3" data-id="element-461"></div>
      <div className="space-y-2" data-id="element-462">
        <div className="flex items-center" data-id="element-463">
          <div className="w-4 h-4 bg-gray-300 rounded-full mr-2" data-id="element-464"></div>
          <div className="h-4 bg-gray-300 rounded w-1/3" data-id="element-465"></div>
        </div>
        <div className="flex items-center" data-id="element-466">
          <div className="w-4 h-4 bg-gray-300 rounded-full mr-2" data-id="element-467"></div>
          <div className="h-4 bg-gray-300 rounded w-1/4" data-id="element-468"></div>
        </div>
        <div className="flex items-center" data-id="element-469">
          <div className="w-4 h-4 bg-gray-300 rounded-full mr-2" data-id="element-470"></div>
          <div className="h-4 bg-gray-300 rounded w-2/5" data-id="element-471"></div>
        </div>
      </div>
      <div className="flex justify-between items-center mt-4" data-id="element-472">
        <div className="h-4 bg-gray-300 rounded w-1/4" data-id="element-473"></div>
        <div className="flex space-x-2" data-id="element-474">
          <div className="h-8 bg-gray-300 rounded w-20" data-id="element-475"></div>
          <div className="h-8 bg-gray-300 rounded w-20" data-id="element-476"></div>
        </div>
      </div>
    </div>;
};
const JobCardSkeleton = () => {
  return <div className="border border-gray-300 rounded-lg p-4 animate-pulse" data-id="element-477">
      <div className="h-6 bg-gray-300 rounded w-2/3 mb-2" data-id="element-478"></div>
      <div className="h-4 bg-gray-300 rounded w-1/2 mb-3" data-id="element-479"></div>
      <div className="flex items-center mt-2 mb-3" data-id="element-480">
        <div className="h-5 bg-gray-300 rounded w-24 mr-3" data-id="element-481"></div>
        <div className="h-5 bg-gray-300 rounded w-32" data-id="element-482"></div>
      </div>
      <div className="flex justify-between items-center mt-3" data-id="element-483">
        <div className="h-8 bg-gray-300 rounded w-24" data-id="element-484"></div>
        <div className="flex space-x-1" data-id="element-485">
          <div className="w-6 h-6 bg-gray-300 rounded-full" data-id="element-486"></div>
          <div className="w-6 h-6 bg-gray-300 rounded-full" data-id="element-487"></div>
          <div className="w-6 h-6 bg-gray-300 rounded-full" data-id="element-488"></div>
        </div>
      </div>
    </div>;
};
const MovieCardSkeleton = () => {
  return <div className="border border-gray-300 rounded-lg overflow-hidden animate-pulse" data-id="element-489">
      <div className="h-40 bg-gray-300" data-id="element-490"></div>
      <div className="p-3" data-id="element-491">
        <div className="h-5 bg-gray-300 rounded w-3/4 mb-2" data-id="element-492"></div>
        <div className="flex items-center space-x-3 mb-2" data-id="element-493">
          <div className="h-4 bg-gray-300 rounded w-16" data-id="element-494"></div>
          <div className="h-4 bg-gray-300 rounded w-16" data-id="element-495"></div>
        </div>
        <div className="flex justify-between items-center" data-id="element-496">
          <div className="h-7 bg-gray-300 rounded w-20" data-id="element-497"></div>
          <div className="flex space-x-1" data-id="element-498">
            <div className="w-6 h-6 bg-gray-300 rounded-full" data-id="element-499"></div>
            <div className="w-6 h-6 bg-gray-300 rounded-full" data-id="element-500"></div>
            <div className="w-6 h-6 bg-gray-300 rounded-full" data-id="element-501"></div>
          </div>
        </div>
      </div>
    </div>;
};
const ArticleCardSkeleton = () => {
  return <div className="border border-gray-300 rounded-lg overflow-hidden animate-pulse" data-id="element-502">
      <div className="h-40 bg-gray-300" data-id="element-503"></div>
      <div className="p-4" data-id="element-504">
        <div className="h-4 bg-gray-300 rounded w-24 mb-2" data-id="element-505"></div>
        <div className="h-6 bg-gray-300 rounded w-5/6 mb-2" data-id="element-506"></div>
        <div className="h-4 bg-gray-300 rounded w-full mb-1" data-id="element-507"></div>
        <div className="h-4 bg-gray-300 rounded w-4/5 mb-3" data-id="element-508"></div>
        <div className="flex justify-between items-center" data-id="element-509">
          <div className="h-4 bg-gray-300 rounded w-20" data-id="element-510"></div>
          <div className="h-4 bg-gray-300 rounded w-24" data-id="element-511"></div>
        </div>
      </div>
    </div>;
};
export default SkeletonLoader;